import type { FieldTemplateProps } from '@rjsf/utils';
import { Box, Typography } from '@mui/material';
import type { ReactElement } from 'react';

export function FieldTemplate({
  id,
  label,
  required,
  children,
  errors,
  displayLabel,
  uiSchema,
  schema,
}: FieldTemplateProps): ReactElement {
  const isObject = schema.type === 'object';
  const showLabel = !isObject && (uiSchema?.['ui:options']?.label ?? displayLabel);
  return (
    <Box className="vtwo:flex vtwo:flex-col vtwo:gap-2 vtwo:mb-2 last:vtwo:mb-0">
      {showLabel && label && (
        <Typography
          variant="body2"
          component="label"
          htmlFor={id}
          className="vtwo:font-medium vtwo:text-gray-700"
        >
          {label}
          {required && (
            <Typography component="span" variant="body2" className="vtwo:text-red-500 vtwo:ml-1">
              *
            </Typography>
          )}
        </Typography>
      )}
      {children}
      {errors}
    </Box>
  );
}
